export const ANALYTICS_PACKAGE = 'jira-jql-builder-basic-cascading-select';
